import * as React from 'react';
import { Card, Box, Typography, Button } from '@mui/material';
import { useParams } from 'react-router-dom';

type QueryParameters =
    {
        paymentId: string
    }

function PaymentErrorPage() {
    const urlParams = useParams<QueryParameters>();

    return <>
        <Box textAlign="left">
            <Typography variant="h2" gutterBottom>Error</Typography>
            <Typography variant="h6" gutterBottom>Something went wrong while taking your payment.</Typography>
        </Box>

        <Card>
            <Box p={5} textAlign="center">
                <p>No payment has been taken from your card. If you want to try again, you can click the button below. Alternatively, you can contact us.</p>
                <Button
                    variant="contained"
                    size="large"
                    type="button"
                    color="primary"
                    href={`/${urlParams.paymentId}`}>Try again</Button>
            </Box>
        </Card>
    </>
}

export default PaymentErrorPage;